module.exports = __webpack_public_path__ + "cancellara-dist/img/chi_siamo_1.03f0d6d6.png";